import {
	AnyAction,
	createAsyncThunk,
	createSlice,
	isAnyOf,
	isRejected,
	isRejectedWithValue,
} from '@reduxjs/toolkit';

import { healthCheckThunk } from './checkConnectionThunk';

export const healthCheck = createAsyncThunk(
	'healthCheck/healthCheck',
	healthCheckThunk,
);

type IState = {
	alive?: boolean;
	tokenExpired: boolean;
};

const initialState: IState = {
	alive: undefined,
	tokenExpired: false,
};

const healthCheckSlice = createSlice({
	name: 'healthCheck',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder
			.addCase(healthCheck.fulfilled, (state, { payload }) => {
				const resultStatus = { ...state, alive: true };
				return resultStatus;
			})
			.addCase(healthCheck.rejected, (state, { payload }) => {
				const resultStatus = { ...state, alive: false };
				return resultStatus;
			})
			.addMatcher(
				isAnyOf(isRejected, isRejectedWithValue),
				(state: IState, response: AnyAction) => {
					const statusCode = response.payload?.status;
					if (statusCode === 412) {
						return {
							...state,
							tokenExpired: true,
						};
					}
				},
			);
	},
});

export default healthCheckSlice.reducer;
